/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Photo_AddInputs */

const en_history_photo_add = /** @type {(inputs: History_Photo_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a photo`)
};

const de_history_photo_add = /** @type {(inputs: History_Photo_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add a photo" |
*
* @param {History_Photo_AddInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_photo_add = /** @type {((inputs?: History_Photo_AddInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Photo_AddInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_photo_add(inputs)
	return en_history_photo_add(inputs)
});